// Use /stats instead of /analytics/* subpaths — ad blockers often block URLs containing "/analytics/".

export const vendorStatsPaths = {
  overview: '/api/vendor/stats',
  summary: '/api/vendor/stats/summary',
  detailed: '/api/vendor/stats/detailed',
  prospectStates: '/api/vendor/stats/prospect-states',
};
